<template>
  <div class="p-2 bg-white rounded">
    <b-row class="align-items-baseline ml-0">
      <p>Số thuê bao</p>
      <b-form-input v-model="phone" class="col-3 mx-2" type="text" v-on:keyup.enter="getList">
      </b-form-input>
      <b-button variant="primary" @click="getList">
        Tra cứu
      </b-button>
    </b-row>
    <p class="mt-2">Danh sách số thuê bao giấy tờ đang đứng tên </p>
    <table class="table">
      <thead>
      <tr>
        <th v-for="header in tableHeaders" :key="header.key" class="border p-1">
          {{ header.label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in tableData">
        <td v-for="key in tableHeaders" :class="key.key==='statusPhone'?'p-0':''" class="border text-center"
            style="padding: 0.5rem">
          <template v-if="key.key==='action'">
            <b-button style="padding-left: 0.1rem;padding-right: 0.1rem" variant="primary" @click="sendOTP(item)">{{
              item[key.key] }}
            </b-button>
          </template>
          <template v-else-if="key.key==='STT'">
            {{ index + 1 }}
          </template>
          <template v-else-if="key.key==='status'">
            {{ item.ussd? item.status===1?"Đã xác nhận":"Sai OTP":"" }}
          </template>
          <template v-else-if="key.key==='statusPhone'">
            <b-row class="border-bottom m-0 align-items-center py-1">
              <b-col class="p-0" cols="9">Gọi đi:</b-col>
              <b-col class="p-0" cols="3">
                <b-form-checkbox v-model="item.oc" disabled value="A"></b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="m-0 py-1">
              <b-col class="p-0" cols="9">Gọi đến:</b-col>
              <b-col class="p-0" cols="3">
                <b-form-checkbox v-model="item.ic" disabled value="A"></b-form-checkbox>
              </b-col>
            </b-row>
          </template>
          <template v-else>{{ item[key.key] }}</template>
        </td>
      </tr>
      </tbody>
    </table>
    <b-modal id="noti-modal" ok-only ok-title="Đóng"
             title="Thông báo">
      <template>
        <h4>Số thuê bao không thuộc danh sách xác thực</h4>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {BButton, BCol, BFormCheckbox, BFormInput, BModal, BRow} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  name: "OtpCheckList",
  components: {BModal, BCol, BFormCheckbox, BButton, BFormInput, BRow},
  data() {
    return {
      tableHeaders: [
        {key: 'STT', label: 'STT'},
        {key: 'msisdn', label: 'Số thuê bao'},
        {key: 'id_number', label: 'Số giấy tờ'},
        {key: 'full_name', label: 'Tên thuê bao'},
        {key: 'birthDay', label: 'Ngày sinh'},
        {key: 'created_date', label: 'Ngày kích hoạt'},
        {key: 'statusPhone', label: 'Trạng thái'},
        {key: 'action', label: 'Thao tác'},
        {key: 'otp', label: 'Mã OTP đã gửi'},
        {key: 'user', label: 'User gửi'},
        {key: 'sent_otp_date', label: 'Thời gian gửi OTP'},
        {key: 'status', label: 'Trạng thái'},
        {key: 'ussd', label: 'USSD KH thao tác'},
        {key: 'ussd_check_date', label: 'Thời gian xác thực OTP'},
        {key: 'updateTime', label: 'Thời gian cập nhật'},
      ],
      tableData: [],
      phone: ''
    }
  },
  methods: {
    getList() {
      this.loading(true)
      useJwt.post('standardized', {
        page: 1,
        pageSize: 100,
        phone: this.phone
      }).then(res => {
        this.loading(false)
        this.tableData = res.data.result
        if (this.tableData.length === 0) {
          this.$bvModal.show('noti-modal')
        }
        this.tableData.forEach((item, index) => {
          item.action = 'Gửi OTP'
          if (item.created_date) {
            item.created_date = moment(item.created_date).format('DD/MM/YYYY HH:mm:ss')
          }
          if (item.sent_otp_date) {
            item.sent_otp_date = moment(item.sent_otp_date).format('DD/MM/YYYY HH:mm:ss')
          }
          if (item.ussd_check_date) {
            item.ussd_check_date = moment(item.ussd_check_date).format('DD/MM/YYYY HH:mm:ss')
          }
          if (item.updateTime) {
            item.updateTime = moment(item.updateTime).format('DD/MM/YYYY HH:mm:ss')
          }
        })
      }).catch(err => {
        this.loading(false)
        console.log(err)
      })

    },
    sendOTP(item) {
      this.loading(true)
      useJwt.get('send-otp-ussd/' + item.id_number + '/' + item.msisdn).then(res => {
        this.loading(false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Gửi OTP thành công",
            icon: "AlertTriangleIcon",
            variant: "success",
          },
        });
      }).catch(err => {
        this.loading(false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Gửi OTP thất bại",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        console.log(err)
      })
    },
  }
}
</script>


<style lang="scss" scoped>

</style>
